
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
    components: {
    }
})
export default class DailyReports extends Vue {
    @Prop({ default: [] }) dailyOperations!: any[]
    fields: any[] = [
        {key: 'dayIndex', label: 'Day Index'},
        {key: 'days', label: 'Days'}, 
        {key: 'depth', label: 'Depth'}, 
        {key: 'description', label: 'Description'},
    ]
}
